<template>
  <div class="container">
    <!-- 头部标题 -->
    <h3 class="header">
      <img src="../../assets/img/logo_z_l.png" alt="" />
    </h3>
    <div class="banner">
      <img :src="detailInfo.headImg" alt="headImg" />
    </div>
    <div class="info">
      <p class="name">{{ detailInfo.productName || '-' }}</p>
      <p class="desc">{{ detailInfo.courseTips || '-' }}</p>
    </div>
    <div class="c">
      <van-tabs v-model="activeName" sticky>
        <!-- 详情 -->
        <van-tab title="课程详情" name="detail">
          <div class="c-detail">
            <img :src="detailInfo.detailImg" alt="detailImg" />
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 底部订阅按钮 -->
    <div class="footer-btn">
      <van-button round type="info" size="small" @click="showMarketFormPopup"
        >免费报名</van-button
      >
    </div>

    <!-- 底部弹出层 START -->
    <van-popup
      v-model="marketFormPopupVisible"
      closeable
      position="bottom"
      class="market-form-popup"
      round
    >
      <h3 class="tit">我要报名</h3>
      <market-form
        ref="my-form-z-l"
        marketFormInfo=""
        :marketFormFieldList="marketFormFieldList"
        @handleSubmit="handleSubmit"
        subBtnFixed
      />
    </van-popup>
    <!-- 底部弹出层 END -->
  </div>
</template>

<script>
import { get, post } from '@/utils/request';
import marketForm from '@/components/marketForm';

const marketFormNo =
  process.env.NODE_ENV === 'development' ? 'BPMF21060001' : 'BPMF21060001'; // 开发/发布环境，默认表单

export default {
  data: function() {
    return {
      activeName: 'detail', // 页签选中值
      marketFormPopupVisible: false, // 表单弹层可见性
      marketFormFieldList: [], // 表单组件列表
      detailInfo: {}, // 详情信息
    };
  },
  components: {
    'market-form': marketForm,
  },
  mounted: function() {
    this.getDetail(); // 获取课程详情--通过url获取
    this.getForm(marketFormNo); // 获取表单数据
  },
  methods: {
    /**
     * 获取课程详情--通过url获取
     */
    getDetail: function() {
      const details = this.$route.query || {};
      this.detailInfo = { ...details };
      document.title = details.productName || '';
    },
    /**
     * 打开表单弹层
     */
    showMarketFormPopup: function() {
      this.marketFormPopupVisible = true;
      this.$nextTick(() => {
        this.$refs['my-form-z-l'].resetForm(); // 每次打开表单--重置
      });
    },
    /**
     * 关闭表单弹层
     */
    closeMarketFormPopup: function() {
      this.marketFormPopupVisible = false;
    },
    /**
     * 初始化表单
     */
    getForm: function(marketFormNo) {
      get('/bp/marketForm/showForm', {
        marketFormNo,
      }).then((res) => {
        const { success, rows } = res || {};
        if (success) {
          const { marketFormFieldList } = rows[0] || {};
          this.marketFormFieldList = marketFormFieldList || [];
        }
      });
    },
    /**
     * 提交表单
     */
    handleSubmit: function(values) {
      const postData = {
        marketFormNo,
        productId: this.detailInfo.productId || '',
        ...values,
      };
      // console.log('postData', postData);

      this.closeMarketFormPopup(); // 关闭弹层

      post('/bp/marketFormItem/saveFormItem', postData).then((res) => {
        const { success } = res || {};
        if (success) {
          this.$dialog.alert({
            title: '已成功报名',
            message: '稍后顾问老师会联系您',
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  // 头部标题内容
  .header {
    height: 44px;
    padding-left: 16px;
    border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    & > img {
      height: 32px;
      width: auto;
    }
  }
  // 头图
  .banner {
    width: 100%;
    // margin-bottom: 20px;
    & > img {
      width: 100%;
      height: auto;
    }
  }
  // 课程信息
  .info {
    padding: 10px 16px;
    border-bottom: 1px solid #ddd;
    .name {
      line-height: 20px;
      font-size: 16px;
      margin-bottom: 6px;
    }
    .desc {
      color: #666;
      font-size: 14px;
      line-height: 18px;
    }
  }

  // 内容
  .c {
    padding-bottom: 52px;
    .c-detail {
      // padding: 0 10px;
      & > img {
        width: 100%;
        height: auto;
      }
    }
  }

  // 底部固定按钮
  .footer-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    background-color: #fff;
    padding: 10px 0;
    border-top: 1px solid #ddd;
    .van-button {
      width: 80%;
      max-width: 614px;
    }
  }
  // 弹出层--表单
  .market-form-popup {
    max-height: 90vh;
    min-height: 50vh;
    .tit {
      text-align: center;
      line-height: 22px;
      margin-top: 16px;
    }
  }
}
</style>
